export default __webpack_public_path__ + "static/media/bg-contact.9edeb3e7.svg";